module.exports = __webpack_public_path__ + "static/img/334_TO8_2580.0b283bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/334_TO8_2580.jpg
// module id = 74DO
// module chunks = 0